import React from 'react';
import CustomIcon from './CustomIcon';

export default class ComingSoonIcon extends CustomIcon {
  svg() {
    return (
      <svg
        width="180"
        height="101"
        viewBox="0 0 180 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M131.701 89L157.946 12.6949L177.287 83.3113C178.071 86.175 175.916 89 172.946 89H131.701Z"
          fill="#DDE9E9"
          stroke="#3B3B3B"
        />
        <path
          d="M35.5714 7.5H153.488C156.579 7.5 158.75 10.5442 157.743 13.4663L129.022 96.7996C128.397 98.615 126.688 99.8333 124.768 99.8333H6.99999C3.91229 99.8333 1.74182 96.7947 2.74324 93.8739L31.3147 10.5405C31.9383 8.72168 33.6486 7.5 35.5714 7.5Z"
          fill="white"
          stroke="#3B3B3B"
        />
        <path
          d="M41.1442 24.9167H47.0259C48.9405 24.9167 50.2692 26.8245 49.6053 28.6203L48.8659 30.6203C48.4668 31.6999 47.4376 32.4167 46.2866 32.4167H40.3727C38.4417 32.4167 37.112 30.4787 37.807 28.677L38.5785 26.677C38.9876 25.6163 40.0073 24.9167 41.1442 24.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M56.4782 24.9167H62.3599C64.2745 24.9167 65.6031 26.8245 64.9393 28.6203L64.1999 30.6203C63.8008 31.6999 62.7716 32.4167 61.6205 32.4167H55.7067C53.7756 32.4167 52.446 30.4787 53.1409 28.677L53.9124 26.677C54.3216 25.6163 55.3413 24.9167 56.4782 24.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M71.8102 24.9167H77.6919C79.6065 24.9167 80.9352 26.8245 80.2713 28.6203L79.532 30.6203C79.1329 31.6999 78.1036 32.4167 76.9526 32.4167H71.0387C69.1077 32.4167 67.778 30.4787 68.473 28.677L69.2445 26.677C69.6536 25.6163 70.6733 24.9167 71.8102 24.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M87.1442 24.9167H93.0259C94.9405 24.9167 96.2692 26.8245 95.6053 28.6203L94.8659 30.6203C94.4668 31.6999 93.4376 32.4167 92.2866 32.4167H86.3727C84.4417 32.4167 83.112 30.4787 83.807 28.677L84.5785 26.677C84.9876 25.6163 86.0073 24.9167 87.1442 24.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M102.478 24.9167H108.36C110.274 24.9167 111.603 26.8245 110.939 28.6203L110.2 30.6203C109.801 31.6999 108.772 32.4167 107.621 32.4167H101.707C99.7756 32.4167 98.446 30.4787 99.1409 28.677L99.9124 26.677C100.322 25.6163 101.341 24.9167 102.478 24.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M117.81 24.9167H123.692C125.607 24.9167 126.935 26.8245 126.271 28.6203L125.532 30.6203C125.133 31.6999 124.104 32.4167 122.953 32.4167H117.039C115.108 32.4167 113.778 30.4787 114.473 28.677L115.244 26.677C115.654 25.6163 116.673 24.9167 117.81 24.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M133.144 24.9167H139.026C140.94 24.9167 142.269 26.8245 141.605 28.6203L140.866 30.6203C140.467 31.6999 139.438 32.4167 138.287 32.4167H132.373C130.442 32.4167 129.112 30.4787 129.807 28.677L130.578 26.677C130.988 25.6163 132.007 24.9167 133.144 24.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M35.8102 38.9167H41.6919C43.6065 38.9167 44.9352 40.8245 44.2713 42.6203L43.532 44.6203C43.1329 45.6999 42.1036 46.4167 40.9526 46.4167H35.0387C33.1077 46.4167 31.778 44.4787 32.473 42.677L33.2445 40.677C33.6536 39.6163 34.6733 38.9167 35.8102 38.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M51.1442 38.9167H57.0259C58.9405 38.9167 60.2692 40.8245 59.6053 42.6203L58.8659 44.6203C58.4668 45.6999 57.4376 46.4167 56.2866 46.4167H50.3727C48.4417 46.4167 47.112 44.4787 47.807 42.677L48.5785 40.677C48.9876 39.6163 50.0073 38.9167 51.1442 38.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M66.4782 38.9167H72.3599C74.2745 38.9167 75.6031 40.8245 74.9393 42.6203L74.1999 44.6203C73.8008 45.6999 72.7716 46.4167 71.6205 46.4167H65.7067C63.7756 46.4167 62.446 44.4787 63.1409 42.677L63.9124 40.677C64.3216 39.6163 65.3413 38.9167 66.4782 38.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M81.8102 38.9167H87.6919C89.6065 38.9167 90.9352 40.8245 90.2713 42.6203L89.532 44.6203C89.1329 45.6999 88.1036 46.4167 86.9526 46.4167H81.0387C79.1077 46.4167 77.778 44.4787 78.473 42.677L79.2445 40.677C79.6536 39.6163 80.6733 38.9167 81.8102 38.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M97.1442 38.9167H103.026C104.94 38.9167 106.269 40.8245 105.605 42.6203L104.866 44.6203C104.467 45.6999 103.438 46.4167 102.287 46.4167H96.3727C94.4417 46.4167 93.112 44.4787 93.807 42.677L94.5785 40.677C94.9876 39.6163 96.0073 38.9167 97.1442 38.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M112.478 38.9167H118.36C120.274 38.9167 121.603 40.8245 120.939 42.6203L120.2 44.6203C119.801 45.6999 118.772 46.4167 117.621 46.4167H111.707C109.776 46.4167 108.446 44.4787 109.141 42.677L109.912 40.677C110.322 39.6163 111.341 38.9167 112.478 38.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M127.81 38.9167H133.692C135.607 38.9167 136.935 40.8245 136.271 42.6203L135.532 44.6203C135.133 45.6999 134.104 46.4167 132.953 46.4167H127.039C125.108 46.4167 123.778 44.4787 124.473 42.677L125.244 40.677C125.654 39.6163 126.673 38.9167 127.81 38.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M30.4782 52.9167H36.3599C38.2745 52.9167 39.6031 54.8245 38.9393 56.6203L38.1999 58.6203C37.8008 59.6999 36.7716 60.4167 35.6205 60.4167H29.7067C27.7756 60.4167 26.446 58.4787 27.1409 56.677L27.9124 54.677C28.3216 53.6163 29.3413 52.9167 30.4782 52.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M45.8102 52.9167H51.6919C53.6065 52.9167 54.9352 54.8245 54.2713 56.6203L53.532 58.6203C53.1329 59.6999 52.1036 60.4167 50.9526 60.4167H45.0387C43.1077 60.4167 41.778 58.4787 42.473 56.677L43.2445 54.677C43.6536 53.6163 44.6733 52.9167 45.8102 52.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M61.1442 52.9167H67.0259C68.9405 52.9167 70.2692 54.8245 69.6053 56.6203L68.8659 58.6203C68.4668 59.6999 67.4376 60.4167 66.2866 60.4167H60.3727C58.4417 60.4167 57.112 58.4787 57.807 56.677L58.5785 54.677C58.9876 53.6163 60.0073 52.9167 61.1442 52.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M76.4782 52.9167H82.3599C84.2745 52.9167 85.6031 54.8245 84.9393 56.6203L84.1999 58.6203C83.8008 59.6999 82.7716 60.4167 81.6205 60.4167H75.7067C73.7756 60.4167 72.446 58.4787 73.1409 56.677L73.9124 54.677C74.3216 53.6163 75.3413 52.9167 76.4782 52.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M91.8102 52.9167H97.6919C99.6065 52.9167 100.935 54.8245 100.271 56.6203L99.532 58.6203C99.1329 59.6999 98.1036 60.4167 96.9526 60.4167H91.0387C89.1077 60.4167 87.778 58.4787 88.473 56.677L89.2445 54.677C89.6536 53.6163 90.6733 52.9167 91.8102 52.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M107.144 52.9167H113.026C114.94 52.9167 116.269 54.8245 115.605 56.6203L114.866 58.6203C114.467 59.6999 113.438 60.4167 112.287 60.4167H106.373C104.442 60.4167 103.112 58.4787 103.807 56.677L104.578 54.677C104.988 53.6163 106.007 52.9167 107.144 52.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M122.478 52.9167H128.36C130.274 52.9167 131.603 54.8245 130.939 56.6203L130.2 58.6203C129.801 59.6999 128.772 60.4167 127.621 60.4167H121.707C119.776 60.4167 118.446 58.4787 119.141 56.677L119.912 54.677C120.322 53.6163 121.341 52.9167 122.478 52.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M25.1442 66.9167H31.0259C32.9405 66.9167 34.2692 68.8245 33.6053 70.6203L32.8659 72.6203C32.4668 73.6999 31.4376 74.4167 30.2866 74.4167H24.3727C22.4417 74.4167 21.112 72.4787 21.807 70.677L22.5785 68.677C22.9876 67.6163 24.0073 66.9167 25.1442 66.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M40.4782 66.9167H46.3599C48.2745 66.9167 49.6031 68.8245 48.9393 70.6203L48.1999 72.6203C47.8008 73.6999 46.7716 74.4167 45.6205 74.4167H39.7067C37.7756 74.4167 36.446 72.4787 37.1409 70.677L37.9124 68.677C38.3216 67.6163 39.3413 66.9167 40.4782 66.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M55.8102 66.9167H61.6919C63.6065 66.9167 64.9352 68.8245 64.2713 70.6203L63.532 72.6203C63.1329 73.6999 62.1036 74.4167 60.9526 74.4167H55.0387C53.1077 74.4167 51.778 72.4787 52.473 70.677L53.2445 68.677C53.6536 67.6163 54.6733 66.9167 55.8102 66.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M20.4782 80.9167H26.3599C28.2745 80.9167 29.6031 82.8245 28.9393 84.6203L28.1999 86.6203C27.8008 87.6999 26.7716 88.4167 25.6205 88.4167H19.7067C17.7756 88.4167 16.446 86.4787 17.1409 84.677L17.9124 82.677C18.3216 81.6163 19.3413 80.9167 20.4782 80.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M35.8102 80.9167H41.6919C43.6065 80.9167 44.9352 82.8245 44.2713 84.6203L43.532 86.6203C43.1329 87.6999 42.1036 88.4167 40.9526 88.4167H35.0387C33.1077 88.4167 31.778 86.4787 32.473 84.677L33.2445 82.677C33.6536 81.6163 34.6733 80.9167 35.8102 80.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M51.1442 80.9167H57.0259C58.9405 80.9167 60.2692 82.8245 59.6053 84.6203L58.8659 86.6203C58.4668 87.6999 57.4376 88.4167 56.2866 88.4167H50.3727C48.4417 88.4167 47.112 86.4787 47.807 84.677L48.5785 82.677C48.9876 81.6163 50.0073 80.9167 51.1442 80.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M71.1442 66.9167H77.0259C78.9405 66.9167 80.2692 68.8245 79.6053 70.6203L78.8659 72.6203C78.4668 73.6999 77.4376 74.4167 76.2866 74.4167H70.3727C68.4417 74.4167 67.112 72.4787 67.807 70.677L68.5785 68.677C68.9876 67.6163 70.0073 66.9167 71.1442 66.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M86.4782 66.9167H92.3599C94.2745 66.9167 95.6031 68.8245 94.9393 70.6203L94.1999 72.6203C93.8008 73.6999 92.7716 74.4167 91.6205 74.4167H85.7067C83.7756 74.4167 82.446 72.4787 83.1409 70.677L83.9124 68.677C84.3216 67.6163 85.3413 66.9167 86.4782 66.9167Z"
          fill="#DDE9E9"
          fill-opacity="0.5"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M101.81 66.9167H107.692C109.607 66.9167 110.935 68.8245 110.271 70.6203L109.532 72.6203C109.133 73.6999 108.104 74.4167 106.953 74.4167H101.039C99.1077 74.4167 97.778 72.4787 98.473 70.677L99.2445 68.677C99.6536 67.6163 100.673 66.9167 101.81 66.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M117.144 66.9167H123.026C124.94 66.9167 126.269 68.8245 125.605 70.6203L124.866 72.6203C124.467 73.6999 123.438 74.4167 122.287 74.4167H116.373C114.442 74.4167 113.112 72.4787 113.807 70.677L114.578 68.677C114.988 67.6163 116.007 66.9167 117.144 66.9167Z"
          fill="#7EBBBB"
          fill-opacity="0.45"
          stroke="#3B3B3B"
          stroke-width="0.5"
        />
        <path
          d="M84.8333 70.6666C84.8333 72.6544 83.7431 74.578 81.7336 76.0587C79.7246 77.5389 76.8774 78.4999 73.6667 78.4999C70.4559 78.4999 67.6087 77.5389 65.5998 76.0587C63.5903 74.578 62.5 72.6544 62.5 70.6666C62.5 68.6788 63.5903 66.7552 65.5998 65.2745C67.6087 63.7942 70.4559 62.8333 73.6667 62.8333C76.8774 62.8333 79.7246 63.7942 81.7336 65.2745C83.7431 66.7552 84.8333 68.6788 84.8333 70.6666Z"
          stroke="#81EAF9"
          stroke-width="3"
        />
        <path
          d="M57.0007 8C57.0007 11.9497 54.085 15 50.6673 15C47.2496 15 44.334 11.9497 44.334 8C44.334 4.05032 47.2496 1 50.6673 1C54.085 1 57.0007 4.05032 57.0007 8Z"
          stroke="#3B3B3B"
          stroke-width="2"
        />
        <rect x="51" y="8" width="10" height="10" fill="white" />
        <path
          d="M85.6667 8C85.6667 11.9497 82.751 15 79.3333 15C75.9157 15 73 11.9497 73 8C73 4.05032 75.9157 1 79.3333 1C82.751 1 85.6667 4.05032 85.6667 8Z"
          stroke="#3B3B3B"
          stroke-width="2"
        />
        <rect x="79.668" y="8" width="10" height="10" fill="white" />
        <path
          d="M114.333 8C114.333 11.9497 111.417 15 107.999 15C104.582 15 101.666 11.9497 101.666 8C101.666 4.05032 104.582 1 107.999 1C111.417 1 114.333 4.05032 114.333 8Z"
          stroke="#3B3B3B"
          stroke-width="2"
        />
        <rect x="108.334" y="8" width="10" height="10" fill="white" />
        <path
          d="M143.001 8C143.001 11.9497 140.085 15 136.667 15C133.25 15 130.334 11.9497 130.334 8C130.334 4.05032 133.25 1 136.667 1C140.085 1 143.001 4.05032 143.001 8Z"
          stroke="#3B3B3B"
          stroke-width="2"
        />
        <rect x="137" y="8" width="10" height="10" fill="white" />
      </svg>
    );
  }
}
